import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import './assets/index.scss';
import 'vue-sonner/style.css';
import Sonner from './components/ui/sonner/Sonner.vue';
import { TooltipProvider } from './components/ui/tooltip';
import { onMounted } from 'vue';
import { useBranding } from '@/composables/useBranding';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { init } = useBranding();

onMounted(() => {
    init();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(TooltipProvider), null, {
    default: _withCtx(() => [
      _createVNode(_component_router_view),
      _createVNode(Sonner)
    ]),
    _: 1
  }))
}
}

})